import React, { FC, MutableRefObject } from 'react';
import { makeStyles } from 'tss-react/mui';

import { transactionsTypes } from 'companion-app-components/flux/transactions';

import FlagField from 'components/QuickenControls/FlagField';

import { RegListItem, styles } from '../styles';
import type { AttributesType, CallbacksType } from '../types';

const useStyles = makeStyles()(styles as Record<string, any>);

interface UserFlagProps {
  attributes: AttributesType;
  callbacks: CallbacksType;
  editable: boolean;
  fieldActive: boolean;
  txn: transactionsTypes.CashFlowTransaction;
  showIcons: boolean;
  focusField: MutableRefObject<HTMLButtonElement | null>;
}

const UserFlag: FC<UserFlagProps> = ({
  attributes,
  callbacks,
  editable,
  fieldActive,
  txn,
  showIcons,
  focusField,
}) => {
  const { classes } = useStyles();
  return (
    <RegListItem
      {...attributes}
      tabIndex={null}
      onClick={null}
      className={classes.iconButtonColumn}
    >
      <FlagField
        classes={{ iconRoot: classes.iconButtonColumn }}
        value={txn.userFlag!}
        autoFocus={fieldActive}
        inputRef={fieldActive ? (input) => { 
          focusField.current = input; // eslint-disable-line
        } : null}
        editable={editable}
        onChange={(e) => callbacks.handleMenu?.('userFlag', txn, e.target.value)}
        show={(txn.userFlag && txn.userFlag !== 'NONE') || editable || showIcons}
      />
    </RegListItem>
  );
};

export default UserFlag;
